import React from 'react'


const Serviceabout = () => {
  return (
    <div className='container mtop-5'>
        <h2 className='heading text-start mb-3'>Our Services – Your Complete <br/>
Guide to Studying Abroad </h2>
<p className='text-muted text-start'>We understand that studying abroad is a life-changing decision. From the moment you consider your first option to the day you step into your dream University and beyond, we’re here to guide you every step of the way. Our services are designed to ensure a smooth, stress-free, and successful journey, covering everything from career counselling to post-departure assistance.

</p>
    </div>
  )
}

export default Serviceabout